import type { FunctionComponent, ReactNode } from 'react';

// Card shell shared by the collapsible audit trail and its skeleton: a rounded
// surface holding the table, with an optional right-aligned footer action.
export const AuditDisplayShell: FunctionComponent<{
    readonly children: ReactNode;
    readonly footerAction: ReactNode;
}> = ({ children, footerAction }) => (
    <div className="group relative flex flex-col">
        <div>
            <div className="overflow-hidden rounded-lg bg-surface-raised shadow-sm">{children}</div>
            {footerAction === null ? null : (
                <div className="flex justify-end py-xs">
                    <div className="shrink-0">{footerAction}</div>
                </div>
            )}
        </div>
    </div>
);
